@if (!this.hidden) {
  <div class="justify-content-center align-content-center h-fit min-h-11 w-fit min-w-44 flex-grow" id="copy-balloon-button-wrapper">
    <button
      (click)="copyValueToClipboard($event)"
      class="transition-bg before:content-[&quot;&quot;] after:content-[&quot;&quot;] after:transition-bg absolute w-44 items-center whitespace-nowrap rounded-full py-2 pl-4 pr-12 text-sm font-semibold text-neutral-0 duration-300 ease-in-out before:absolute before:-bottom-3 before:left-0 before:block before:h-6 before:w-full after:absolute after:-bottom-2 after:left-1/2 after:block after:h-6 after:w-6 after:-translate-x-1/2 after:rotate-45 after:rounded-md after:duration-300 after:ease-in-out after:[clip-path:polygon(100%_0%,100%_100%,0%_100%)] group-hover:flex"
      [ngClass]="valueHasBeenCopied ? 'bg-neutral-100 after:bg-neutral-100' : 'bg-primary-100 after:bg-primary-100'">
      {{ valueHasBeenCopied ? ('common.copied-to-clipboard.label' | translate) : ('common.copy-to-clipboard.label' | translate) }}
      <pay-icon
        class="absolute right-4 opacity-0 transition-opacity duration-300 ease-in-out"
        [ngClass]="{ 'opacity-100': !valueHasBeenCopied }"
        shape="copy"
        size="xs" />
      <pay-icon
        class="absolute right-4 opacity-0 transition-opacity duration-300 ease-in-out"
        [ngClass]="{ 'opacity-100': valueHasBeenCopied }"
        shape="checkmark"
        size="xs" />
    </button>
  </div>
}
